"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledIs = require("../../utils/styled-is");
var _Plus = _interopRequireDefault(require("@honeybook/icons/dist/icons/Plus16"));
var _HBTabs = require("./HBTabs.styles");
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _HBIconButton = _interopRequireDefault(require("../HBIconButton/HBIconButton"));
var _TabItem = _interopRequireDefault(require("./TabItem"));
var _GradientScrollContainer = _interopRequireDefault(require("./GradientScrollContainer"));
var _HBUIProvider = require("../HBUIProvider/HBUIProvider");
var _templateObject;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var addTabBottomPositionBySize = {
  sm: '-6px',
  md: '-4px',
  lg: '-2px'
};
var AddTabButton = function AddTabButton(_ref) {
  var addTabProps = _ref.addTabProps,
    size = _ref.size;
  var onAddTabClick = function onAddTabClick(ev) {
    ev.currentTarget.blur();
    addTabProps.onClick();
  };
  return /*#__PURE__*/_react["default"].createElement(_HBIconButton["default"], {
    buttonTheme: "neutral-invisible",
    disabled: addTabProps.isDisabled,
    icon: _Plus["default"],
    label: "add tab",
    onClick: onAddTabClick,
    size: "xs",
    testIdName: "add-tab",
    tooltip: addTabProps.tooltip,
    tooltipProps: _objectSpread({
      targetContainerStyle: {
        alignSelf: 'start',
        transform: "translateY(".concat(addTabBottomPositionBySize[size], ")")
      }
    }, addTabProps.tooltipProps)
  });
};
var HBTabs = function HBTabs(_ref2) {
  var _tabs$find;
  var className = _ref2.className,
    testIdName = _ref2.testIdName,
    testId = _ref2.testId,
    tabs = _ref2.tabs,
    selectedTab = _ref2.selectedTab,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'md' : _ref2$size,
    _ref2$stretchToFill = _ref2.stretchToFill,
    stretchToFill = _ref2$stretchToFill === void 0 ? false : _ref2$stretchToFill,
    onClick = _ref2.onClick,
    maxTabWidth = _ref2.maxTabWidth,
    addTabProps = _ref2.addTabProps,
    noShadow = _ref2.noShadow,
    selectedHighlightColor = _ref2.selectedHighlightColor,
    renderTab = _ref2.renderTab;
  var scrollRef = (0, _react.useRef)(null);
  var isIconOnly = tabs.every(function (tab) {
    return !tab.title;
  });
  var selected = selectedTab || ((_tabs$find = tabs.find(function (tab) {
    return !tab.isDisabled;
  })) === null || _tabs$find === void 0 ? void 0 : _tabs$find.id);
  var _useHBUI = (0, _HBUIProvider.useHBUI)(),
    LinkComponent = _useHBUI.LinkComponent;
  (0, _react.useEffect)(function () {
    if (!selectedTab && selected && onClick) {
      onClick(selected);
    }
  }, [onClick, selected, selectedTab]);
  var tabsContainerTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'tabs-container',
    componentName: 'HBTabs'
  });
  return /*#__PURE__*/_react["default"].createElement(FlexContainer, {
    className: className,
    noShadow: noShadow
  }, /*#__PURE__*/_react["default"].createElement(_GradientScrollContainer["default"], {
    itemCount: tabs.length,
    scrollRef: scrollRef,
    stretchToFill: stretchToFill
  }, /*#__PURE__*/_react["default"].createElement(_HBTabs.Tabs, {
    ref: scrollRef,
    "data-testid": tabsContainerTestId
  }, tabs.map(function (tab) {
    var _tab$menuItems;
    return /*#__PURE__*/_react["default"].createElement(_TabItem["default"], {
      key: tab.id,
      hasMenu: !!((_tab$menuItems = tab.menuItems) !== null && _tab$menuItems !== void 0 && _tab$menuItems.length),
      isActive: selected === tab.id,
      isIconOnly: isIconOnly,
      maxTabWidth: maxTabWidth,
      onClick: onClick,
      renderTab: renderTab,
      scrollRef: scrollRef,
      selectedHighlightColor: selectedHighlightColor,
      size: size,
      stretchToFill: stretchToFill,
      tab: tab,
      LinkComponent: LinkComponent
    });
  }))), addTabProps && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, addTabProps.renderWrapper ? addTabProps.renderWrapper(/*#__PURE__*/_react["default"].createElement(AddTabButton, {
    addTabProps: addTabProps,
    size: size
  })) : /*#__PURE__*/_react["default"].createElement(AddTabButton, {
    addTabProps: addTabProps,
    size: size
  })));
};
var _default = exports["default"] = HBTabs; // -------------------------------- Styles -------------------------------- //
var FlexContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBTabs__FlexContainer",
  componentId: "sc-1d54b4d-0"
})(["display:flex;gap:4px;", ""], (0, _styledIs.isNot)('noShadow')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        box-shadow: 0px 1px 0px 0px rgba(0, 18, 71, 0.08);\n    "]))));
//# sourceMappingURL=HBTabs.js.map